import { createRoot } from "react-dom/client";
import { bootCrmAuth } from "./auth";
import { App } from "./App";
import { applyCrmTheme, readCrmAccent, readCrmTheme } from "./theme/theme";
import "./index.css";
import "./theme/plus.css";

applyCrmTheme(readCrmTheme(), readCrmAccent());

void bootCrmAuth().then((session) => {
  if (!session.ok) return;
  const root = document.getElementById("root");
  if (!root) return;
  createRoot(root).render(<App session={session} />);
});
